import { RouteConfig } from 'vue-router'
import VueI18n from 'vue-i18n'

const OpportunityListView: DynamicImport = () => import(/* webpackChunkName: "opportunities" */ '../views/OpportunityListView.vue')
const OpportunityItemView: DynamicImport = () => import(/* webpackChunkName: "opportunities" */ '../views/OpportunityItemView/OpportunityItemView.vue')
const FunnelsView: DynamicImport = () => import(/* webpackChunkName: "opportunities" */ '../views/FunnelsView.vue')

const routes: (i18n: VueI18n) => Array<RouteConfig> = (i18n) => ([
  {
    path: '/opportunities/funnels',
    name: 'funnels',
    component: FunnelsView,
    meta: {
      title: i18n.t('opportunities.funnel.pageTitle'),
      pageHeader: false,
      appModule: 'opportunities',
      userPermission: ['opportunities', 1]
    }
  },
  {
    path: '/opportunities/opportunities',
    name: 'opportunity-list',
    component: OpportunityListView,
    meta: {
      title: i18n.t('opportunities.opportunities.pageTitle'),
      appModule: 'opportunities',
      userPermission: ['opportunities', 1],
      pageHeader: false
    }
  },
  {
    path: '/opportunities/opportunities/:id',
    name: 'opportunity-item',
    component: OpportunityItemView,
    meta: {
      title: i18n.t('opportunities.opportunities.item.genericPageTitle'),
      pageHeader: false,
      appModule: 'opportunities',
      userPermission: ['opportunities', 1],
      appClass: { 'opportunity-item': true }
    }
  }
])

export default routes
